import { highlightAllUnder } from 'prismjs';

const elements = document.querySelectorAll<HTMLElement>(
  '[data-block="codeblock"]'
);

for (const element of elements) {
  highlightAllUnder(element);
}
